import apiClient from '@/services/AccountClient'

export default {
  fetchAll (params = {}, options) {
    const defaultSort = 'createdAt,desc'

    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/swift-messages',
      {
        ...params,
        sort: (params.sort != null)
          ? [params.sort, defaultSort]
          : defaultSort
      },
      options
    )
  },
  fetchById (id) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/swift-messages/${id}`
    )
  },
  fetchByMessageCloudReference (messageCloudReference) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/swift-messages/message-cloud-reference/${messageCloudReference}`
    )
  },
  fetchMessageTypes () {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/swift-messages/message-types'
    )
  }
}
